var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.5L6.71062 17.2599C5.90104 18.0645 4.7453 18.4155 3.625 18.197V18.197C2.00819 17.8818 0.841272 16.4653 0.841269 14.8181L0.841268 14.4695C0.841267 14.0032 0.925623 13.5408 1.09026 13.1045L1.39019 12.3098C1.79264 11.2434 2.40491 10.2686 3.19076 9.44307L10.0245 2.26401C10.6418 1.61554 11.5472 1.32677 12.4259 1.49812V1.49812C13.8475 1.77532 14.7753 3.15248 14.4981 4.57408L14.3521 5.32248C14.2251 5.97405 13.9093 6.57387 13.4439 7.04733L8.99746 11.5717L6.68933 13.8078C6.41323 14.0753 6.0439 14.2249 5.65948 14.2249V14.2249C4.4993 14.2249 3.7902 12.9507 4.40167 11.9648L4.90299 11.1564C4.96753 11.0524 5.04144 10.9544 5.12382 10.8638L10 5.5",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.833d67d5361b65b34f512f9428a15934.svg";
export { ForwardRef as ReactComponent };